"use client";

import React from "react";

interface ConditionScaleProps {
  selectedCondition: string;
}

const conditions = [
  { name: "Fair", level: 1 },
  { name: "Good", level: 2 },
  { name: "Very Good", level: 3 },
  { name: "Excellent", level: 4 },
  { name: "New with Tags", level: 5 },
];

const ConditionScale: React.FC<ConditionScaleProps> = ({
  selectedCondition,
}) => {
  const selectedLevel =
    conditions.find((c) => c.name === selectedCondition)?.level || 0;

  return (
    <div className="condition-scale">
      <p className="font-raleway text-sm mb-2">
        Condition: <strong>{selectedCondition}</strong>
      </p>
      <div className="flex items-center gap-1">
        {conditions.map((condition) => (
          <div
            key={condition.name}
            className={`h-4 flex-1 border ${
              condition.level <= selectedLevel
                ? "bg-green border-green"
                : "bg-light-grey border-grey"
            }`}
            title={condition.name}
          />
        ))}
      </div>
      <div className="flex justify-between text-xs text-grey mt-1 font-raleway">
        <span>Fair</span>
        <span>Excellent</span>
      </div>
    </div>
  );
};

export default ConditionScale;
